import rem from './utils/rem'
import merge from './utils/merge'

export default {
    rem,
    merge,
}



// WEBPACK FOOTER //
// ./src/utils.js